// // export default EmiDueReport;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import "../assets/Loan/EmiDueReport.css";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { useDispatch, useSelector } from "react-redux";

// const EmiDueReport = () => {
//   // const superAdminId = Number(localStorage.getItem("userId")) || 0;
//   const [emis, setEmis] = useState([]);
//   const [company, setCompany] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [filter, setFilter] = useState("pending");
//   const [isPending,setIsPending]=useState(true);
//   const [isToday,setIsToday]=useState(false);
//   const [isTomorrow,setIsTomorrow]=useState(false);
//   const [isOverdue,setIsOverdue]=useState(false);
//   const [selectedFilters, setSelectedFilters] = useState(["pending"]);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [selectedIds, setSelectedIds] = useState([]);
//   console.log("selectedIds are",selectedIds);

//   const handleSelectClick = (id, isChecked) => {
//     setSelectedIds((prev) =>
//       isChecked
//         ? [...prev, id]
//         : prev.filter((item) => item !== id)
//     );
//     // console.log(selectedIds);

//   };

//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   const baseUrl = "https://payyug.in/api/loan-emi";
//   // const apiUrls = {
//   //   pending: `${baseUrl}/overdue?branchId=${superAdminId}`,
//   //   today: `${baseUrl}/today?branchId=${superAdminId}`,
//   //   upcoming: `${baseUrl}/upcoming7days?branchId=${superAdminId}`,
//   // };

//   useEffect(() => {
//     const fetchEmis = async (page=currentPage) => {
//       setLoading(true);
//       try {
//         // const res = await axios.get(apiUrls[filter]);
//         const res= await axios.get(`https://payyug.in/api/group-loan/emi/list-filter`,{
//           params:{
//               superAdminId:profile.superAdminId,
//               filterType:selectedFilters,
//               page,
//               limit:rowsPerPage,
//               // fromDate:"2025-12-20",
//               // toDate:"2025-12-25",
//               ...(fromDate && { fromDate }),
//               ...(toDate && { toDate }),
//           }
//         })
//         console.log("emi due reports",res.data)
//         setEmis(res.data.data || []);
//         setTotalPages(res.data.totalPages)
//       } catch (err) {
//         setError("Failed to fetch EMI due report");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmis();
//   }, [profile?.superAdminId,selectedFilters,currentPage,rowsPerPage,fromDate,toDate]);

//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(`https://payyug.in/api/get-company?superAdminId=14`);
//         if (!res.ok) throw new Error("Failed");
//         const data = await res.json();
//         const info = data.data || data;
//         if (info.logo)
//           info.logoUrl = `https://payyug.in/${info.logo.replace(/^images\//, "")}`;
//         setCompany(info);
//       } catch (err) {
//         console.error("Company fetch error:", err);
//       }
//     };
//     fetchCompany();
//   }, [profile?.superAdminId]);

//   const handlebulkpay = async () => {
//     if (selectedIds.length === 0) return;

//     setLoading(true);
//     try {
//       await axios.post(
//         "https://payyug.in/api/loan/pay-emi-bulk",
//         {
//           emiIds: selectedIds,
//           paymentMode: "Cash",
//           paymentDate: new Date().toISOString().split("T")[0],
//         }
//       );
//       setSelectedIds([]);
//     } catch (err) {
//       setError("Bulk payment failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleFilter = (filter) => {
//   setSelectedFilters((prev) => {
//     if (prev.includes(filter)) {
//       // remove
//       return prev.filter((f) => f !== filter);
//     } else {
//       // add
//       return [...prev, filter];
//     }
//   });
// };

//   if (loading) return <div className="EmiDueReport-loading">Loading EMI Report...</div>;
//   // if (error) return <div className="EmiDueReport-error">some error found ......{error}</div>;

//   // const totalPages = Math.ceil(emis.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = emis;
//   // .slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // ✅ TOTAL CALCULATION ADDED
//   const totals = currentData.reduce(
//     (acc, emi) => {
//       acc.emiAmount += emi.emiAmount || 0;
//       acc.principal += emi.principalComponent || 0;
//       acc.interest += emi.interestComponent || 0;
//       acc.outstanding += emi.outstanding || 0;
//       return acc;
//     },
//     { emiAmount: 0, principal: 0, interest: 0, outstanding: 0 }
//   );

//   // // ✅ PDF Same as your code (unchanged)
//   // const handleDownloadPDF = async () => {
//   //   const doc = new jsPDF("p", "mm", "a4");
//   //   const pageWidth = doc.internal.pageSize.width;
//   //   doc.setDrawColor(0);
//   //   doc.rect(8, 8, pageWidth - 16, 280);

//   //   if (company?.logoUrl) {
//   //     try {
//   //       const logoResp = await fetch(company.logoUrl);
//   //       const logoBlob = await logoResp.blob();
//   //       const reader = new FileReader();
//   //       await new Promise((resolve) => {
//   //         reader.onload = () => {
//   //           doc.addImage(reader.result, "PNG", 15, 12, 25, 25);
//   //           resolve();
//   //         };
//   //         reader.readAsDataURL(logoBlob);
//   //       });
//   //     } catch {}
//   //   }

//   //   doc.setFont("helvetica", "bold");
//   //   doc.setFontSize(15);
//   //   doc.text(company?.name?.toUpperCase() || "COMPANY NAME", 45, 18);
//   //   doc.setFont("helvetica", "normal");
//   //   doc.setFontSize(11);
//   //   doc.text(company?.address || "Company Address", 45, 24);
//   //   doc.text(`Email: ${company?.email || ""}`, 45, 30);
//   //   doc.text(`Phone: ${company?.contact || ""}`, 45, 36);
//   //   doc.line(10, 42, pageWidth - 10, 42);
//   //   doc.setFont("helvetica", "bold");
//   //   doc.setFontSize(13);
//   //   doc.text("EMI DUE REPORT", pageWidth / 2, 50, { align: "center" });

//   //   const tableColumn = ["Sr.No", "Customer Name", "Loan Number", "EMI No.", "EMI Amount", "Principal", "Interest", "Outstanding", "Due Date"];

//   //   const tableRows = currentData.map((emi, i) => [
//   //     startIndex + i + 1,
//   //     emi.customerName,
//   //     emi.loanNumber,
//   //     emi.emiNumber,
//   //     emi.emiAmount,
//   //     emi.principalComponent.toLocaleString(),
//   //     emi.interestComponent.toLocaleString(),
//   //     emi.outstanding.toLocaleString(),
//   //     new Date(emi.dueDate).toLocaleDateString("en-IN"),
//   //   ]);

//   //   autoTable(doc, {
//   //     startY: 56,
//   //     head: [tableColumn],
//   //     body: tableRows,
//   //     theme: "grid",
//   //     styles: { fontSize: 7, cellPadding: 3, halign: "center" },
//   //     headStyles: { fontStyle: "bold", fontSize: 7 },
//   //   });

//   //   doc.save("EMI_Demand_Sheet.pdf");
//   // };

//   const handleDownloadPDF = async () => {
//   const doc = new jsPDF("p", "mm", "a4");
//   const pageWidth = doc.internal.pageSize.width;
//   doc.setDrawColor(0);
//   doc.rect(8, 8, pageWidth - 16, 280);

//   // ✅ Add company logo
//   if (company?.logoUrl) {
//     try {
//       const logoResp = await fetch(company.logoUrl);
//       const logoBlob = await logoResp.blob();
//       const reader = new FileReader();
//       await new Promise((resolve) => {
//         reader.onload = () => {
//           doc.addImage(reader.result, "PNG", 15, 12, 25, 25);
//           resolve();
//         };
//         reader.readAsDataURL(logoBlob);
//       });
//     } catch {}
//   }

//   // ✅ Company Info
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(15);
//   doc.text(company?.name?.toUpperCase() || "COMPANY NAME", 45, 18);
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(11);
//   doc.text(company?.address || "Company Address", 45, 24);
//   doc.text(`Email: ${company?.email || ""}`, 45, 30);
//   doc.text(`Phone: ${company?.contact || ""}`, 45, 36);
//   doc.line(10, 42, pageWidth - 10, 42);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(13);
//   doc.text("EMI DUE REPORT", pageWidth / 2, 50, { align: "center" });

//   // ✅ Table Header
//   const tableColumn = [
//     "Sr.No",
//     "Customer Name",
//     "Loan Number",
//     "EMI No.",
//     "EMI Amount",
//     "Principal",
//     "Interest",
//     "Outstanding",
//     "Due Date",
//   ];

//   // ✅ Table Rows
//   const tableRows = currentData.map((emi, i) => [
//     startIndex + i + 1,
//     emi.customerName,
//     emi.loanNumber,
//     emi.emiNumber,
//     emi.emiAmount.toLocaleString(),
//     emi.principalComponent.toLocaleString(),
//     emi.interestComponent.toLocaleString(),
//     emi.outstanding.toLocaleString(),
//     new Date(emi.dueDate).toLocaleDateString("en-IN"),
//   ]);

//   // ✅ Add Total Row to Table
//   const totalRow = [
//     { content: "Total", colSpan: 4, styles: { halign: "right", fontStyle: "bold" } },
//     { content: totals.emiAmount.toLocaleString(), styles: { fontStyle: "bold" } },
//     { content: totals.principal.toLocaleString(), styles: { fontStyle: "bold" } },
//     { content:totals.interest.toLocaleString(), styles: { fontStyle: "bold" } },
//     { content: totals.outstanding.toLocaleString(), styles: { fontStyle: "bold" } },
//     { content: "", styles: { halign: "center" } },
//   ];

//   // ✅ Generate PDF Table
//   autoTable(doc, {
//     startY: 56,
//     head: [tableColumn],
//     body: tableRows,
//     theme: "grid",
//     styles: { fontSize: 7, cellPadding: 3, halign: "center" },
//     headStyles: { fontStyle: "bold", fontSize: 7 },
//     foot: [totalRow],
//     footStyles: {
//       fillColor: [220, 220, 220],
//       textColor: 20,
//       fontStyle: "bold",
//       fontSize: 8,
//     },
//   });

//   // ✅ Optional: Summary box below table
//   const finalY = doc.lastAutoTable.finalY + 10;
//   doc.setFontSize(9);

//   doc.save("EMI_Demand_Sheet.pdf");
// };

//   return (
//     <div className="EmiDueReport-wrapper">
//       <h1 className="EmiDueReport-title">📋 EMI Due Report</h1>

//       {/* <div className="EmiDueReport-filters">
//         {["pending", "today", "tomorrow","overdue"].map((f) => (
//           <button key={f}
//             className={`filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => { setFilter(f); setCurrentPage(1); }}>
//             {f.charAt(0).toUpperCase() + f.slice(1)}
//           </button>
//         ))}
//       </div> */}

//       <div className="EmiDueReport-filters">
//         {["pending", "today", "tommorrow", "overdue"].map((f) => (
//           <button
//             key={f}
//             className={`filter-btn ${
//               selectedFilters.includes(f) ? "active" : ""
//             }`}
//             onClick={() => {
//               toggleFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.charAt(0).toUpperCase() + f.slice(1)}
//           </button>
//         ))}
//         <div className={`date-field ${fromDate ? "selected" : ""}`}>
//           <label>From Date</label>
//           <div className="date-input-wrapper">
//             <input
//               className={`date-input ${fromDate ? "date-selected" : ""}`}
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//             />
//             {fromDate && (
//               <span className="clear-btn" onClick={() => setFromDate("")}>
//                 ✕
//               </span>
//             )}
//           </div>
//         </div>

//         <div className={`date-field ${toDate ? "selected" : ""}`}>
//           <label>To Date</label>
//           <div className="date-input-wrapper">
//             <input
//               type="date"
//               value={toDate}
//               className={`date-input ${toDate ? "date-selected" : ""}`}
//               onChange={(e) => setToDate(e.target.value)}
//             />
//             {toDate && (
//               <span className="clear-btn" onClick={() => setToDate("")}>
//                 ✕
//               </span>
//             )}
//           </div>
//         </div>

//       </div>

//       <div className="EmiDueReport-controls">
//         <label>
//           Show{" "}
//           <select value={rowsPerPage} onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
//             <option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
//           </select>{" "}
//           entries
//         </label>
//         <div>
//              <button
//               className="filter-btn"
//               disabled={selectedIds.length === 0}
//               onClick={handlebulkpay}
//             >
//               Pay
//             </button>

//             <button className="filter-btn" onClick={handleDownloadPDF}>📄 Download PDF</button>
//         </div>
//       </div>

//       <div className="EmiDueReport-table-container">
//         <table className="EmiDueReport-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
//               <th>Due Date</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="10" className="EmiDueReport-empty">✅ No records found</td>
//               </tr>
//             ) : (
//               currentData.map((emi, i) => (
//                 <tr key={emi.id}>
//                   <td>{startIndex + i + 1}</td>
//                   <td>{emi.loanAccount.memberName}</td>
//                   <td>{emi.loanAccount.loanAccountNumber}</td>
//                   <td>{emi.installmentNo}</td>
//                   <td>₹{emi.emiAmount.toLocaleString()}</td>
//                   <td>₹{emi.principalComponent.toLocaleString()}</td>
//                   <td>₹{emi.interestComponent.toLocaleString()}</td>
//                   <td>₹{emi.outstanding.toLocaleString()}</td>
//                   <td>{new Date(emi.dueDate).toLocaleDateString("en-IN")}</td>
//                   <td>
//                     <span className={`EmiDueReport-status ${emi.status === "pending" ? "pending" : "paid"}`}>
//                       {emi.status}
//                     </span>
//                   </td>
//                   <td>
//                     <input
//                       type="checkbox"
//                       checked={selectedIds.includes(emi.id)}
//                       onChange={(e) => handleSelectClick(emi.id, e.target.checked)}
//                     />
//                   </td>

//                 </tr>
//               ))
//             )}
//           </tbody>

//           {/* ✅ TOTALS ROW */}
//           <tfoot>
//             <tr className="EmiDueReport-total-row">
//               <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>Total:</td>
//               <td style={{ fontWeight: "bold" }}>₹{totals.emiAmount.toLocaleString()}</td>
//               <td style={{ fontWeight: "bold" }}>₹{totals.principal.toLocaleString()}</td>
//               <td style={{ fontWeight: "bold" }}>₹{totals.interest.toLocaleString()}</td>
//               <td style={{ fontWeight: "bold" }}>₹{totals.outstanding.toLocaleString()}</td>
//               <td colSpan="2"></td>
//             </tr>
//           </tfoot>
//         </table>
//       </div>

//       <div className="EmiDueReport-pagination">
//         <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>⬅ Prev</button>
//         <span className="pagination-info">Page {currentPage} of {totalPages}</span>
//         <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>Next ➡</button>
//       </div>
//     </div>
//   );
// };

// export default EmiDueReport;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "../assets/Loan/EmiDueReport.css";
import { toast } from "react-toastify";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";

const EmiDueReport = () => {
  const superAdminId = Number(localStorage.getItem("userId")) || 0;
  const [emis, setEmis] = useState([]);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter, setFilter] = useState("pending");
  const [selectedIds, setSelectedIds] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
  // console.log("selectedIds are", selectedIds);

  const baseUrl = "https://payyug.in/api/loan-emi";
  const apiUrls = {
    pending: `${baseUrl}/overdue?branchId=${superAdminId}`,
    today: `${baseUrl}/today?branchId=${superAdminId}`,
    upcoming: `${baseUrl}/upcoming7days?branchId=${superAdminId}`,
  };
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchEmis = async () => {
    setLoading(true);
    try {
      const res = await axios.get(apiUrls[filter]);
      setEmis(res.data.emis || []);
      console.log("loan emis:", res);
    } catch (err) {
      setError("Failed to fetch EMI due report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmis();
  }, [filter]);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
        );
        if (!res.ok) throw new Error("Failed");
        const data = await res.json();
        const info = data.data || data;
        if (info.logo)
          info.logoUrl = `https://payyug.in/${info.logo.replace(/^images\//, "")}`;
        setCompany(info);
      } catch (err) {
        console.error("Company fetch error:", err);
      }
    };
    fetchCompany();
  }, [superAdminId]);

  const handleSelectAll = (isChecked) => {
    const currentPageIds = currentData.map((emi) => emi.id);

    setSelectedIds((prev) => {
      if (isChecked) {
        // add missing ids only
        const newIds = currentPageIds.filter((id) => !prev.includes(id));
        return [...prev, ...newIds];
      } else {
        // remove current page ids
        return prev.filter((id) => !currentPageIds.includes(id));
      }
    });
  };

  const handleSelectClick = (id, isChecked) => {
    setSelectedIds((prev) =>
      isChecked ? [...prev, id] : prev.filter((item) => item !== id),
    );
  };

  /* ================= BULK PAY ================= */
const handlebulkpay = async () => {
  if (selectedIds.length === 0) {
    toast.warn("Please select at least one EMI");
    return;
  }

  const isConfirmed = window.confirm("Are you sure you want to pay selected EMIs?");
  if (!isConfirmed) return;

  setLoading(true);
  try {
    const res = await axios.post(
      "https://payyug.in/api/loan/pay-emi-bulk",
      {
        emiIds: selectedIds,
        paymentMode: "Cash",
        paymentDate: new Date().toISOString().split("T")[0],
      }
    );

    toast.success(res.data?.message || "Bulk Payment Successful");

    // ✅ clear selection only after success
    setSelectedIds([]);

    // ✅ refresh list
    await fetchEmis();
  } catch (err) {
    toast.error(err.response?.data?.message || "Bulk payment failed");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  setCurrentPage(1);
}, [fromDate, toDate,searchQuery]);


// const filteredEmis = emis.filter((emi) => {
//   if (!fromDate && !toDate) return true;

//   const dueDate = new Date(emi.dueDate);

//   if (fromDate && dueDate < new Date(fromDate)) return false;
//   if (toDate && dueDate > new Date(toDate)) return false;

//   return true;
// });

const filteredEmis = emis.filter((emi) => {
  // ===== Date Filter =====
  const dueDate = new Date(emi.dueDate);

  if (fromDate && dueDate < new Date(fromDate)) {
    return false;
  }

  if (toDate) {
    const endDate = new Date(toDate);
    endDate.setHours(23, 59, 59, 999); 
    if (dueDate > endDate) {
      return false;
    }
  }

  // ===== Search Filter =====
  if (!searchQuery.trim()) return true;

  const query = searchQuery.toLowerCase();

  return (
    emi.customerName?.toLowerCase().includes(query) ||
    emi.loanNumber?.toLowerCase().includes(query) 
    // emi.emiNumber?.toString().toLowerCase().includes(query) ||
    // emi.status?.toLowerCase().includes(query) ||
    // emi.emiAmount?.toString().includes(query) ||
    // emi.outstanding?.toString().includes(query)
  );
});

const totalPages = Math.ceil(filteredEmis.length / rowsPerPage);

const startIndex = (currentPage - 1) * rowsPerPage;

const currentData = filteredEmis.slice(
  startIndex,
  startIndex + rowsPerPage
);



  if (loading)
    return <div className="EmiDueReport-loading">Loading EMI Report...</div>;
  if (error) return <div className="EmiDueReport-error">{error}</div>;

  // const totalPages = Math.ceil(emis.length / rowsPerPage);
  // const startIndex = (currentPage - 1) * rowsPerPage;
  // const currentData = emis.slice(startIndex, startIndex + rowsPerPage);

    const isAllSelected =
    currentData.length > 0 &&
    currentData.every((emi) => selectedIds.includes(emi.id));

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

  // ✅ TOTAL CALCULATION ADDED
  const totals = currentData.reduce(
    (acc, emi) => {
      acc.emiAmount += emi.emiAmount || 0;
      acc.principal += emi.principalComponent || 0;
      acc.interest += emi.interestComponent || 0;
      acc.outstanding += emi.outstanding || 0;
      return acc;
    },
    { emiAmount: 0, principal: 0, interest: 0, outstanding: 0 },
  );

  // // ✅ PDF Same as your code (unchanged)
  // const handleDownloadPDF = async () => {
  //   const doc = new jsPDF("p", "mm", "a4");
  //   const pageWidth = doc.internal.pageSize.width;
  //   doc.setDrawColor(0);
  //   doc.rect(8, 8, pageWidth - 16, 280);

  //   if (company?.logoUrl) {
  //     try {
  //       const logoResp = await fetch(company.logoUrl);
  //       const logoBlob = await logoResp.blob();
  //       const reader = new FileReader();
  //       await new Promise((resolve) => {
  //         reader.onload = () => {
  //           doc.addImage(reader.result, "PNG", 15, 12, 25, 25);
  //           resolve();
  //         };
  //         reader.readAsDataURL(logoBlob);
  //       });
  //     } catch {}
  //   }

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(15);
  //   doc.text(company?.name?.toUpperCase() || "COMPANY NAME", 45, 18);
  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(11);
  //   doc.text(company?.address || "Company Address", 45, 24);
  //   doc.text(`Email: ${company?.email || ""}`, 45, 30);
  //   doc.text(`Phone: ${company?.contact || ""}`, 45, 36);
  //   doc.line(10, 42, pageWidth - 10, 42);
  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(13);
  //   doc.text("EMI DUE REPORT", pageWidth / 2, 50, { align: "center" });

  //   const tableColumn = ["Sr.No", "Customer Name", "Loan Number", "EMI No.", "EMI Amount", "Principal", "Interest", "Outstanding", "Due Date"];

  //   const tableRows = currentData.map((emi, i) => [
  //     startIndex + i + 1,
  //     emi.customerName,
  //     emi.loanNumber,
  //     emi.emiNumber,
  //     emi.emiAmount,
  //     emi.principalComponent.toLocaleString(),
  //     emi.interestComponent.toLocaleString(),
  //     emi.outstanding.toLocaleString(),
  //     new Date(emi.dueDate).toLocaleDateString("en-IN"),
  //   ]);

  //   autoTable(doc, {
  //     startY: 56,
  //     head: [tableColumn],
  //     body: tableRows,
  //     theme: "grid",
  //     styles: { fontSize: 7, cellPadding: 3, halign: "center" },
  //     headStyles: { fontStyle: "bold", fontSize: 7 },
  //   });

  //   doc.save("EMI_Demand_Sheet.pdf");
  // };

//   const handleDownloadPDF = async () => {
//   const doc = new jsPDF("p", "mm", "a4");
//   const pageWidth = doc.internal.pageSize.width;
//   const pageHeight = doc.internal.pageSize.height;


//     // ================= LOGO =================
// // ================= LOGO WITH BORDER =================
// const logoX = 15;
// const logoY = 12;
// const logoSize = 25;
// const logoPadding = 2;

// // Border color & thickness
// doc.setDrawColor(0);
// doc.setLineWidth(0.2);

// // Calculate center of logo
// const centerX = logoX + logoSize / 2;
// const centerY = logoY + logoSize / 2;

// // Radius = half of logo + padding
// const radius = logoSize / 2 + logoPadding;

// // Draw circle
// doc.circle(centerX, centerY, radius);

// // Logo image
// if (company?.logoUrl) {
//   try {
//     const logoResp = await fetch(company.logoUrl);
//     const logoBlob = await logoResp.blob();
//     const reader = new FileReader();
//     await new Promise((resolve) => {
//       reader.onload = () => {
//         doc.addImage(reader.result, "PNG", logoX, logoY, logoSize, logoSize);
//         resolve();
//       };
//       reader.readAsDataURL(logoBlob);
//     });
//   } catch {
//     // silent fail
//   }
// }

//   // ================= COMPANY NAME (AUTO WRAP) =================
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(14);

//   const nameX = logoX + logoSize + 5;
//   const nameY = 18;
//   const nameMaxWidth = pageWidth - nameX - 15;

//   const companyNameText = doc.splitTextToSize(
//     (company?.name || "COMPANY NAME").toUpperCase(),
//     nameMaxWidth
//   );

//   doc.text(companyNameText, nameX, nameY);

//   // Calculate Y after company name
//   let currentY = nameY + companyNameText.length * 6;

//   // ================= COMPANY DETAILS =================
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(11);

//   const detailX = nameX;
//   const detailMaxWidth = nameMaxWidth;

//   // Address
//   const addressText = doc.splitTextToSize(
//     company?.address || "Company Address",
//     detailMaxWidth-50
//   );
//   doc.text(addressText, detailX, currentY);
//   currentY += addressText.length * 5;

//   // Email
//   const emailText = doc.splitTextToSize(
//     `Email: ${company?.email || "-"}`,
//     detailMaxWidth
//   );
//   doc.text(emailText, detailX, currentY);
//   currentY += emailText.length * 5;

//   // Phone
//   const phoneText = doc.splitTextToSize(
//     `Phone: ${company?.contact || "-"}`,
//     detailMaxWidth
//   );
//   doc.text(phoneText, detailX, currentY);
//   currentY += phoneText.length * 5;

//   // Divider
//   doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

//     // ================= REPORT TITLE =================
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(13);
//   doc.text(
//     "Emi Due Report",
//     pageWidth / 2,
//     currentY + 14,
//     { align: "center" }
//   );

//     // ✅ Table Header
//     const tableColumn = [
//       "Sr.No",
//       "Customer Name",
//       "Loan Number",
//       "EMI No.",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//     ];

//     // ✅ Table Rows
//     const tableRows = currentData.map((emi, i) => [
//       startIndex + i + 1,
//       emi.customerName,
//       emi.loanNumber,
//       emi.emiNumber,
//       `Rs. ${emi.emiAmount.toLocaleString("en-IN")}`,
//       `Rs. ${emi.principalComponent.toLocaleString("en-IN")}`,
//       `Rs. ${emi.interestComponent.toLocaleString("en-IN")}`,
//       `Rs. ${emi.outstanding.toLocaleString("en-IN")}`,
//       new Date(emi.dueDate).toLocaleDateString("en-IN"),
//     ]);

//     // ✅ Add Total Row to Table
//     const totalRow = [
//       {
//         content: "Total",
//         colSpan: 4,
//         styles: { halign: "right", fontStyle: "bold" },
//       },
//       {
//         content: totals.emiAmount.toLocaleString(),
//         styles: { fontStyle: "bold" },
//       },
//       {
//         content: totals.principal.toLocaleString(),
//         styles: { fontStyle: "bold" },
//       },
//       {
//         content: totals.interest.toLocaleString(),
//         styles: { fontStyle: "bold" },
//       },
//       {
//         content: totals.outstanding.toLocaleString(),
//         styles: { fontStyle: "bold" },
//       },
//       { content: "", styles: { halign: "center" } },
//     ];

//     // ✅ Generate PDF Table
// autoTable(doc, {
//   startY: currentY + 20,
//   head: [tableColumn],
//   body: tableRows,
//   foot: [totalRow],

//   showFoot: "lastPage", // 🔥 IMPORTANT LINE

//   theme: "grid",
//   styles: {
//     fontSize: 7,
//     cellPadding: 3,
//     halign: "center",
//   },
//   columnStyles: {
//     // 2: { halign: "right", cellWidth: 25 }, // EMI Amount
//     4: { halign: "right", cellWidth: 22 }, // EMI Amount
//     5: { halign: "right", cellWidth: 22 }, // Principal
//     6: { halign: "right", cellWidth: 22 }, // Interest
//     7: { halign: "right", cellWidth: 22 }, // Outstanding
//   },
//   headStyles: {
//     fontStyle: "bold",
//     fontSize: 7,
//   },
//   footStyles: {
//     fillColor: [220, 220, 220],
//     textColor: 20,
//     fontStyle: "bold",
//     fontSize: 8,
//   },
//   alternateRowStyles: {
//     fillColor: [245, 245, 245],
//   },


//   didDrawPage: function () {
//     const pageWidth = doc.internal.pageSize.width;
//     const pageHeight = doc.internal.pageSize.height;

//     doc.setDrawColor(0);
//     doc.setLineWidth(0.2);

//     // Page border on EVERY page
//     doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
//   },
// });


//     // ✅ Optional: Summary box below table
//     const finalY = doc.lastAutoTable.finalY + 10;
//     doc.setFontSize(9);

//     doc.save("EMI_Demand_Sheet.pdf");
//   };

const handleDownloadPDF = async () => {
  const doc = new jsPDF("p", "mm", "a4",true);
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // ================= 1. DEFINE TABLE DATA =================
  const tableColumn = [
    "Sr.No",
    "Customer Name",
    "Loan Number",
    "EMI No.",
    "EMI Amount",
    "Principal",
    "Interest",
    "Outstanding",
    "Due Date",
  ];

  const tableRows = currentData.map((emi, i) => [
    (startIndex || 0) + i + 1,
    emi.customerName || "-",
    emi.loanNumber || "-",
    emi.emiNumber || "-",
    `Rs. ${Number(emi.emiAmount).toLocaleString("en-IN")}`,
    `Rs. ${Number(emi.principalComponent).toLocaleString("en-IN")}`,
    `Rs. ${Number(emi.interestComponent).toLocaleString("en-IN")}`,
    `Rs. ${Number(emi.outstanding).toLocaleString("en-IN")}`,
    new Date(emi.dueDate).toLocaleDateString("en-IN"),
  ]);

  const totalRow = [
    {
      content: "Total",
      colSpan: 4,
      styles: { halign: "right", fontStyle: "bold" },
    },
    {
      content: totals.emiAmount.toLocaleString("en-IN"),
      styles: { fontStyle: "bold" },
    },
    {
      content: totals.principal.toLocaleString("en-IN"),
      styles: { fontStyle: "bold" },
    },
    {
      content: totals.interest.toLocaleString("en-IN"),
      styles: { fontStyle: "bold" },
    },
    {
      content: totals.outstanding.toLocaleString("en-IN"),
      styles: { fontStyle: "bold" },
    },
    { content: "", styles: { halign: "center" } },
  ];

  // ================= 2. HEADER SETTINGS =================
  const margin = 10;
  const headerY = 15;
  const logoSize = 22;
  const centerX = pageWidth / 2;

  // Draw Page Border (Matches LoanCard style)
  doc.setDrawColor(0);
  doc.setLineWidth(0.2);
  doc.rect(8, 8, pageWidth - 16, pageHeight - 16);

  // --- LOGO (Left) ---
  if (company?.logoUrl) {
    try {
      const response = await fetch(company.logoUrl);
      const blob = await response.blob();
      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
      // Square logo box like the card
      doc.rect(margin, headerY, logoSize + 4, logoSize + 4); 
      doc.addImage(base64, "PNG", margin + 2, headerY + 2, logoSize, logoSize);
    } catch (e) {
      console.error("Logo fetch failed", e);
    }
  }

  // --- COMPANY DETAILS (Center) ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  const companyName = (company?.name || "COMPANY NAME").toUpperCase();
  doc.text(companyName, centerX, headerY + 5, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  let detailsY = headerY + 11;
  const lines = [
    `CIN: ${company?.cin || "-"}`,
    `Regd. Office: ${company?.address || "-"}`,
    // `Website: ${company?.domain || "-"}`,
    `Contact: ${company?.contact || "-"}`,
    `Email: ${company?.email || "-"}`
  ];

  lines.forEach((line) => {
    const splitText = doc.splitTextToSize(line, pageWidth - 110);
    doc.text(splitText, centerX, detailsY, { align: "center" });
    detailsY += (splitText.length * 4.5);
  });

  // --- QR CODE (Right) ---
  // if (company?.qrCodeUrl) {
  //   try {
  //     const qrResponse = await fetch(company.qrCodeUrl);
  //     const qrBlob = await qrResponse.blob();
  //     const qrBase64 = await new Promise((resolve) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => resolve(reader.result);
  //       reader.readAsDataURL(qrBlob);
  //     });
  //     doc.addImage(qrBase64, "PNG", pageWidth - margin - 22, headerY, 20, 20);
  //   } catch (e) {}
  // }

  // ================= 3. DIVIDER & TITLE =================
  let currentY = Math.max(detailsY, headerY + logoSize) + 5;
  doc.setLineWidth(0.5);
  doc.line(margin, currentY, pageWidth - margin, currentY);

  currentY += 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("EMI DUE REPORT", centerX, currentY, { align: "center" });
  
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text(`Date: ${new Date().toLocaleDateString("en-GB")}`, pageWidth - margin - 2, currentY, { align: "right" });

  // ================= 4. GENERATE TABLE =================
  autoTable(doc, {
    startY: currentY + 5,
    head: [tableColumn],
    body: tableRows,
    foot: [totalRow],
    showFoot: "lastPage",
    theme: "grid",
    styles: {
      fontSize: 7,
      cellPadding: 2,
      halign: "center",
    },
    headStyles: {
      fillColor: [240, 240, 240], // Light grey header
      textColor: 0,
      fontStyle: "bold",
      lineWidth: 0.1,
    },
    footStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: "bold",
    },
    columnStyles: {
      1: { halign: "left" }, // Customer Name
      4: { halign: "right" }, 
      5: { halign: "right" },
      6: { halign: "right" },
      7: { halign: "right" },
    },
    didDrawPage: (data) => {
      // Page Border on every page
      doc.setDrawColor(0);
      doc.setLineWidth(0.2);
      doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
    },
  });

  // ================= 5. SAVE =================
  doc.save(`EMI_Due_Report_${new Date().getTime()}.pdf`);
};

  return (
    <div className="EmiDueReport-wrapper">
      <h1 className="EmiDueReport-title">📋 EMI Due Report</h1>

      {/* <div className="EmiDueReport-filters">
        {["pending", "today", "upcoming"].map((f) => (
          <button
            key={f}
            className={`filter-btn ${filter === f ? "active" : ""}`}
            onClick={() => {
              setFilter(f);
              setCurrentPage(1);
            }}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div> */}

      <div className="EmiDueReport-filters">
          {["pending","today","upcoming"].map((f)=>(
            <button
              key={f}
              className={`filter-btn ${filter === f ? "active" : ""}`}
              onClick={()=>{
                setFilter(f);
                setCurrentPage(1);
              }}
            >
              {f.charAt(0).toUpperCase()+f.slice(1)}
            </button>
          ))}

          {/* From Date */}
          <div className={`date-field ${fromDate ? "selected":""}`}>
            <label>From</label>
            <div className="date-input-wrapper">
              <input
                type="date"
                value={fromDate}
                onChange={(e)=>setFromDate(e.target.value)}
                className="date-field-input"
              />
              {fromDate && (
                <span className="clear-btn" onClick={()=>setFromDate("")}>✕</span>
              )}
            </div>
          </div>

          {/* To Date */}
          <div className={`date-field ${toDate ? "selected":""}`}>
            <label>To</label>
            <div className="date-input-wrapper">
              <input
                type="date"
                value={toDate}
                onChange={(e)=>setToDate(e.target.value)}
                className="date-field-input"
              />
              {toDate && (
                <span className="clear-btn" onClick={()=>setToDate("")}>✕</span>
              )}
            </div>
          </div>

      </div>

      <div className="EmiDueReport-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={50000}>All</option>
          </select>{" "}
          entries
        </label>
        <input
        type="search"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
        <div className="">
          {
            filter==="today" && 
            <button
                className="filter-btn"
                disabled={loading}
                onClick={handlebulkpay}
              >
                Bulk Pay
            </button>
          }
          <button className="filter-btn" onClick={handleDownloadPDF}>
            📄 Download PDF
          </button>
        </div>
      </div>

      <div className="EmiDueReport-table-container">
        <table className="EmiDueReport-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Loan Number</th>
              <th>EMI Number</th>
              <th>EMI Amount</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>Outstanding</th>
              <th>Due Date</th>
              <th>Status</th>
              {
                filter==="today" 
                 && 
                <th style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection:"column",
                    alignContent: "center",
                  }}>Select For Bulk Pay <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
               </th>
              }
            </tr>
          </thead>

          <tbody>
            {currentData.length === 0 ? (
              <tr>
                <td colSpan="11" className="EmiDueReport-empty">
                  ✅ No records found
                </td>
              </tr>
            ) : (
              currentData.map((emi, i) => (
                <tr key={emi.id}>
                  <td>{startIndex + i + 1}</td>
                  <td>{emi.customerName}</td>
                  <td>{emi.loanNumber}</td>
                  <td>{emi.emiNumber}</td>
                  <td>₹{emi.emiAmount.toLocaleString()}</td>
                  <td>₹{emi.principalComponent.toLocaleString()}</td>
                  <td>₹{emi.interestComponent.toLocaleString()}</td>
                  <td>₹{emi.outstanding.toLocaleString()}</td>
                  <td>{new Date(emi.dueDate).toLocaleDateString("en-GB").replaceAll("/","-")}</td>
                  <td>
                    <span
                      className={`EmiDueReport-status ${emi.status === "pending" ? "pending" : "paid"}`}
                    >
                      {emi.status}
                    </span>
                  </td>
                  {
                    filter==="today" && 
                    <td style={{textAlign:"center"}}>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(emi.id)}
                      onChange={(e) =>
                        handleSelectClick(emi.id, e.target.checked)
                      }
                    />
                   </td>
                  }
                </tr>
              ))
            )}
          </tbody>

          {/* ✅ TOTALS ROW */}
          <tfoot>
            <tr className="EmiDueReport-total-row">
              <td
                colSpan="4"
                style={{ textAlign: "right", fontWeight: "bold" }}
              >
                Total:
              </td>
              <td style={{ fontWeight: "bold" }}>
                ₹{totals.emiAmount.toLocaleString()}
              </td>
              <td style={{ fontWeight: "bold" }}>
                ₹{totals.principal.toLocaleString()}
              </td>
              <td style={{ fontWeight: "bold" }}>
                ₹{totals.interest.toLocaleString()}
              </td>
              {/* <td style={{ fontWeight: "bold" }}>
                ₹{totals.outstanding.toLocaleString()}
              </td> */}
              <td colSpan="3"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="EmiDueReport-pagination">
        <button
          className="pagination-btn"
          onClick={handlePrev}
          disabled={currentPage === 1}
        >
          ⬅ Prev
        </button>
        <span className="pagination-info">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className="pagination-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default EmiDueReport;
